import React, { useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Stack from '@mui/material/Stack';
import SectionCard from '../../components/ui/SectionCard';
import EmptyState from '../../components/ui/EmptyState';
import PlayerAvatar from '../../components/ui/PlayerAvatar';
import Box from '@mui/material/Box';
import { cardColor } from '../jogos/GameCard';

// Cartões levados na pelada: retângulo na cor do cartão com a quantidade (só os que o jogador levou)
const Cartoes = ({ linha }) => {
  const itens = [['amarelo', linha.amarelos], ['azul', linha.azuis], ['vermelho', linha.vermelhos]].filter(([, qtd]) => qtd > 0);
  if (itens.length === 0) return <span style={{ opacity: 0.4 }}>-</span>;
  return (
    <Stack direction="row" spacing={0.75} justifyContent="center">
      {itens.map(([cor, qtd]) => (
        <Stack key={cor} direction="row" spacing={0.25} alignItems="center" title={`Cartão ${cor}`}>
          <Box sx={{ width: 10, height: 14, borderRadius: 0.5, bgcolor: cardColor[cor] }} />
          {qtd > 1 && <Box component="span" sx={{ fontSize: 12, fontWeight: 700 }}>{qtd}</Box>}
        </Stack>
      ))}
    </Stack>
  );
};

const EstatisticasJogadores = ({ estatisticas = {}, fetchGameActive }) => {

  useEffect(() => {
    if (fetchGameActive !== undefined) fetchGameActive()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const linhas = Object.keys(estatisticas)
    .map((key) => estatisticas[key])
    .sort((a, b) => b.vitorias - a.vitorias || a.derrotas - b.derrotas || (b.gols || 0) - (a.gols || 0));

  return (
    <SectionCard title="Estatísticas da pelada" subtitle="Vitórias, empates, derrotas, gols e cartões de cada jogador hoje">
      {linhas.length === 0 ? (
        <EmptyState title="Sem partidas finalizadas" />
      ) : (
        <TableContainer>
          <Table size="small" sx={{ '& td, & th': { px: { xs: 0.75, sm: 1.5 } } }}>
            <TableHead>
              <TableRow>
                <TableCell>Jogador</TableCell>
                <TableCell align="center">V</TableCell>
                <TableCell align="center">E</TableCell>
                <TableCell align="center">D</TableCell>
                <TableCell align="center" title="Gols">G</TableCell>
                <TableCell align="center">Cartões</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {linhas.map((linha) => (
                <TableRow key={linha.user_name} hover>
                  <TableCell>
                    <Stack direction="row" spacing={1.25} alignItems="center">
                      <PlayerAvatar userId={linha.guest ? null : linha.user} name={linha.user_name} size={30} />
                      <span>{linha.user_name}</span>
                    </Stack>
                  </TableCell>
                  <TableCell align="center" sx={{ color: 'success.main', fontWeight: 700 }}>{linha.vitorias}</TableCell>
                  <TableCell align="center">{linha.empates}</TableCell>
                  <TableCell align="center" sx={{ color: 'error.main', fontWeight: 700 }}>{linha.derrotas}</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 700 }}>{linha.gols ? `⚽ ${linha.gols}` : <span style={{ opacity: 0.4 }}>-</span>}</TableCell>
                  <TableCell align="center"><Cartoes linha={linha} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </SectionCard>
  );
};

export default EstatisticasJogadores;
